import { useEffect } from "react";

const Calendly = ({ type }) => {

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const url =
    type === "group"
      ? "https://calendly.com/signbook-support/30min?hide_gdpr_banner=1"
      : "https://calendly.com/signbook-support/30min?hide_gdpr_banner=1";

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "1000px",
      }}
    >
      <div
        className="calendly-inline-widget"
        data-url={url}
        style={{
          width: "100%",
          height: "750px",
        }}
      ></div>
    </div>
  );
};

export default Calendly;
